import {GridColDef} from "@mui/x-data-grid";
import {TranslationFunction} from "../../../../../store/localization/TranslMessasge";
import {CommonTranslationKey} from "../../CommonTranslationKey";

export function createCollectionsGridColDef(_transl: TranslationFunction): GridColDef[] {
    return [
        {
            field: 'name',
            headerName: _transl(CommonTranslationKey.TITLE),
            width: 300
        },
        {
            field: 'description',
            headerName: _transl(CommonTranslationKey.DESCRIPTION),
            width: 300
        },
        {
            field: 'code',
            headerName: _transl(CommonTranslationKey.CODE),
            width: 150,
            hide: true
        },
    ]
}
